'use client';

import { useMedia } from '@/context/MediaContext';
import { getMediaSourceType } from '@/utils/mediaUtils';
import MediaFrame from './MediaFrame';
import VideoJSPlayer from './players/VideoJSPlayer';

const MediaController: React.FC = () => {

  const { state, actions } = useMedia();

  const {
    isVisible,
    isPlaying,
    currentMedia,
    currentTime,
    duration,
    volume,
    isMuted,
    metadata,
    bufferedSegments,
    error,
    progress,
  } = state;

  const {
    showPlayer,
    togglePlayPause,
    seek,
    setVolume,
    toggleMute,
    hidePlayer,
    updateTime,
    updateBuffered,
    setPlayingState,
    setError,
  } = actions;

  const sourceType = getMediaSourceType(currentMedia || '');

  const handleMediaFrameClose = () => {
    hidePlayer();
  };

  const handleTimeUpdate = (currentTime: number, duration: number): void => {
    updateTime(currentTime, duration);
  };

  const handleError = (error: unknown): void => {
    console.error('Media Player Error:', error);
  };

  return (
    <MediaFrame
      title={metadata?.title || ''}
      isVisible={isVisible}
      onClose={handleMediaFrameClose}
    >
      {isVisible && (
        <VideoJSPlayer
          sources={{ src: currentMedia as string, type: sourceType }}
          options={{
            autoPlay: isPlaying,
            controls: true,
            responsive: true,
            liveui: true,
            fluid: true,
            volume: volume,
            muted: isMuted,
            preload: 'auto',
            aspectRatio: '16:9',
            experimentalSvgIcons: true,
            html5: {
              vhs: {
                overrideNative: true,
                enableLowInitialPlaylist: true,
                enableLowLatencyMode: true,
                llhls: true,
                smoothQualityChange: true,
                limitRenditionByPlayerDimensions: true,
                maxPlaylistRetries: 5,
                liveBackBufferLength: 10,
                liveSyncDuration: 1.5
              }
            },
            liveTracker: {
              trackingThreshold: 10,
              liveTolerance: 5
            },
            controlBar: {
              pictureInPictureToggle: true,
            }
          }}
          poster={metadata?.cover || ''}
          onTimeUpdate={(t: any) => handleTimeUpdate(t.currentTime, t.duration)}
          onError={handleError}
          onPlay={() => setPlayingState(true)}
          onPause={() => setPlayingState(false)}
          isPlaying={isPlaying}
        />
      )}
    </MediaFrame>
  );
};

export default MediaController;


